<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class='h100vh-100'>
        <BatchManagementButton @batchManagementNotices='batchManagementNotices' :taskStatusOfBatch='taskStatusOfBatch'></BatchManagementButton>
        <BatchManagementTable ref='batchManagementTable' @taskStatusChange='taskStatusChange'></BatchManagementTable>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../../layouts/BasicLayout';
import BatchManagementButton from '../../../../components/subscriberMicro/mcsSubscriber/batch/BatchManagementButton';
import BatchManagementTable from '../../../../components/subscriberMicro/mcsSubscriber/batch/BatchManagementTable';

export default {
  name: "BatchManagement",
  components: {
    BasicLayout,
    BatchManagementButton,
    BatchManagementTable
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('MCS.addUserManagement')}/${this.$t('MCS.mcsManagement')}/${this.$t('MCS.batchManagement')}`
      },
      taskStatusOfBatch: 5,
    };
  },
  methods: {
    taskStatusChange(msg) {
      this.taskStatusOfBatch = msg;
    },
    batchManagementNotices(type) {
      switch (type) {
        case 'import':
          this.$refs.batchManagementTable.import();
          break;
        case 'modify':
          this.$refs.batchManagementTable.modify();
          break;
        case 'refresh':
          this.$refs.batchManagementTable.refresh();
          break;
        case 'start':
          this.$refs.batchManagementTable.start();
          break;
        case 'delete':
          this.$refs.batchManagementTable.delete();
          break;
        case 'cancel':
          this.$refs.batchManagementTable.cancel();
          break;
        case 'detail':
          this.$refs.batchManagementTable.detail();
          break;
        case 'templateDownload':
          this.$refs.batchManagementTable.download();
          break;
        default:
      }
    }
  }
}
</script>
